module.exports = __webpack_public_path__ + "img/02-txt-info.0ab1ef4d.png";